import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InspectionProcess from "./component";
import { resetCarList, reloadCarList } from "../car-listing/actions";
import { updateSelectedOnScreenFilter, clearAllFilters } from "../filters/actions";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            reloadCarListConnect: reloadCarList,
            resetCarListConnect: resetCarList,
            updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
            clearAllFiltersConnect: clearAllFilters
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InspectionProcess);
